import { render } from "./LanguageSwitcher.vue?vue&type=template&id=0ca0c8ca&scoped=true&ts=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=0ca0c8ca&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca0c8ca"]])

export default __exports__